import React, { useState } from 'react';
import { ChevronDown, XCircle, ExternalLink, PlusCircle, Pencil, Trash2 } from 'lucide-react';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { FilterBar, FilterDef, SortOption } from './FilterBar';
import { GpBadge } from './GpBadge';
const PORTFOLIO_DATA = [{
  id: 1,
  fundManager: 'Waterloo Capital',
  partnership: 'Waterloo Diversified Fund LP II',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Infrastructure',
  vintage: '2019',
  commitment: '$32,000,000.00',
  nav: '$12,797,986.00',
  pctTotalNav: '3.72%'
}, {
  id: 2,
  fundManager: 'Niagara Growth',
  partnership: 'Niagara Growth Equity Fund V',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Venture',
  vintage: '2015',
  commitment: '$46,000,000.00',
  nav: '$22,679,854.00',
  pctTotalNav: '6.59%'
}, {
  id: 3,
  fundManager: 'Sherbrooke Capital Partners',
  partnership: 'Sherbrooke Capital Secondary Fund IV',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Secondaries',
  vintage: '2020',
  commitment: '$31,000,000.00',
  nav: '$27,975,112.00',
  pctTotalNav: '8.13%'
}, {
  id: 4,
  fundManager: 'Kingston Partners',
  partnership: 'Kingston Fund III',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Buyout',
  vintage: '2021',
  commitment: '$29,000,000.00',
  nav: '$18,639,420.00',
  pctTotalNav: '5.42%'
}, {
  id: 5,
  fundManager: 'Laval Global',
  partnership: 'Laval Global Partners Fund II',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Buyout',
  vintage: '2018',
  commitment: '$48,000,000.00',
  nav: '$12,269,995.00',
  pctTotalNav: '3.57%'
}, {
  id: 6,
  fundManager: 'Maple Tree',
  partnership: 'MapleTree Private Equity Fund I',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Buyout',
  vintage: '2018',
  commitment: '$26,000,000.00',
  nav: '$20,558,908.00',
  pctTotalNav: '5.97%'
}, {
  id: 7,
  fundManager: 'Collingwood Energy',
  partnership: 'Collingwood Energy Opportunities Fund',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Infrastructure',
  vintage: '2021',
  commitment: '$16,000,000.00',
  nav: '$14,592,366.00',
  pctTotalNav: '4.24%'
}, {
  id: 8,
  fundManager: 'Gatineau Real Assets',
  partnership: 'Gatineau Real Assets Fund',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Infrastructure',
  vintage: '2020',
  commitment: '$37,000,000.00',
  nav: '$35,963,548.00',
  pctTotalNav: '10.45%'
}, {
  id: 9,
  fundManager: 'Stratford Credit',
  partnership: 'Stratford Credit Fund V',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Credit',
  vintage: '2020',
  commitment: '$25,000,000.00',
  nav: '$23,602,880.00',
  pctTotalNav: '6.86%'
}, {
  id: 10,
  fundManager: 'Collingwood Energy',
  partnership: 'Collingwood Energy Infrastructure Fund II',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Infrastructure',
  vintage: '2020',
  commitment: '$22,000,000.00',
  nav: '$18,400,000.00',
  pctTotalNav: '5.35%'
}, {
  id: 11,
  fundManager: 'Kingston Partners',
  partnership: 'Kingston Growth Equity Fund IV',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Buyout',
  vintage: '2020',
  commitment: '$35,000,000.00',
  nav: '$28,100,000.00',
  pctTotalNav: '8.17%'
}, {
  id: 12,
  fundManager: 'Kingston Partners',
  partnership: 'Kingston Asia-Pacific Fund I',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Venture',
  vintage: '2021',
  commitment: '$18,000,000.00',
  nav: '$9,200,000.00',
  pctTotalNav: '2.67%'
}, {
  id: 13,
  fundManager: 'Laval Global',
  partnership: 'Laval Global Credit Opportunities Fund',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Credit',
  vintage: '2021',
  commitment: '$20,000,000.00',
  nav: '$17,800,000.00',
  pctTotalNav: '5.17%'
}, {
  id: 14,
  fundManager: 'Niagara Growth',
  partnership: 'Niagara Growth Venture Fund III',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Venture',
  vintage: '2019',
  commitment: '$28,000,000.00',
  nav: '$21,300,000.00',
  pctTotalNav: '6.19%'
}, {
  id: 15,
  fundManager: 'Stratford Credit',
  partnership: 'Stratford Credit Opportunities Fund II',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Credit',
  vintage: '2019',
  commitment: '$30,000,000.00',
  nav: '$26,500,000.00',
  pctTotalNav: '7.70%'
}, {
  id: 16,
  fundManager: 'Stratford Credit',
  partnership: 'Stratford Senior Lending Fund',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Credit',
  vintage: '2021',
  commitment: '$15,000,000.00',
  nav: '$13,100,000.00',
  pctTotalNav: '3.81%'
}, {
  id: 17,
  fundManager: 'Waterloo Capital',
  partnership: 'Waterloo Capital Real Estate Fund',
  fx: 'USD',
  recordDate: '31/12/2025',
  strategy: 'Infrastructure',
  vintage: '2020',
  commitment: '$24,000,000.00',
  nav: '$20,600,000.00',
  pctTotalNav: '5.99%'
}];
const STRATEGY_DATA = [{
  name: 'Infrastructure',
  value: 29.41,
  color: '#458b85'
}, {
  name: 'Buyout',
  value: 23.53,
  color: '#2d5a56'
}, {
  name: 'Credit',
  value: 23.53,
  color: '#7c6bbf'
}, {
  name: 'Venture',
  value: 17.65,
  color: '#e07a5f'
}, {
  name: 'Secondaries',
  value: 5.88,
  color: '#d4a843'
}];
const GEOGRAPHY_DATA = [{
  name: 'North America',
  value: 44.45,
  color: '#e07a5f'
}, {
  name: 'Europe',
  value: 22.22,
  color: '#458b85'
}, {
  name: 'Europe, North America, Asia-Pacific',
  value: 11.11,
  color: '#7c6bbf'
}, {
  name: 'North America, Europe',
  value: 11.11,
  color: '#2563eb'
}, {
  name: 'Europe, Asia-Pacific',
  value: 11.11,
  color: '#d4a843'
}];
const VINTAGE_DATA = [{
  year: '2015',
  NAV: 22,
  Unfunded: 24
}, {
  year: '2018',
  NAV: 33,
  Unfunded: 41
}, {
  year: '2019',
  NAV: 13,
  Unfunded: 19
}, {
  year: '2020',
  NAV: 87,
  Unfunded: 6
}, {
  year: '2021',
  NAV: 33,
  Unfunded: 12
}];
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  name,
  value
}: any) => {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius * 1.2;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const textAnchor = x > cx ? 'start' : 'end';
  // Split long names for Geography chart
  const words = name.split(', ');
  return <text x={x} y={y} fill="#666" textAnchor={textAnchor} dominantBaseline="central" fontSize={10} data-id="element-351">
      {words.map((word: string, i: number) => <tspan x={x} dy={i === 0 ? 0 : 12} key={i} data-id="element-352">
          {word}
        </tspan>)}
      <tspan x={x} dy={12} data-id="element-353">{`${value}%`}</tspan>
    </text>;
};
export function PortfolioTab() {
  const [strategyFilter, setStrategyFilter] = useState('');
  const [vintageFilter, setVintageFilter] = useState('');
  const [sortBy, setSortBy] = useState('name-asc');
  const filters: FilterDef[] = [{
    key: 'strategy',
    label: 'Filter by Strategy',
    options: [{
      value: 'Infrastructure',
      label: 'Infrastructure'
    }, {
      value: 'Venture',
      label: 'Venture'
    }, {
      value: 'Secondaries',
      label: 'Secondaries'
    }, {
      value: 'Buyout',
      label: 'Buyout'
    }, {
      value: 'Credit',
      label: 'Credit'
    }]
  }, {
    key: 'vintage',
    label: 'Filter by Vintage',
    options: [{
      value: '2015',
      label: '2015'
    }, {
      value: '2018',
      label: '2018'
    }, {
      value: '2019',
      label: '2019'
    }, {
      value: '2020',
      label: '2020'
    }, {
      value: '2021',
      label: '2021'
    }]
  }];
  const sortOptions: SortOption[] = [{
    value: 'name-asc',
    label: 'Sort: Name A–Z'
  }, {
    value: 'name-desc',
    label: 'Sort: Name Z–A'
  }, {
    value: 'commitment-desc',
    label: 'Sort: Commitment (High-Low)'
  }, {
    value: 'nav-desc',
    label: 'Sort: NAV (High-Low)'
  }, {
    value: 'pct-desc',
    label: 'Sort: % Total NAV (High-Low)'
  }];
  const filterValues = {
    strategy: strategyFilter,
    vintage: vintageFilter
  };
  const handleFilterChange = (key: string, value: string) => {
    if (key === 'strategy') setStrategyFilter(value);
    if (key === 'vintage') setVintageFilter(value);
  };
  const handleClearAll = () => {
    setStrategyFilter('');
    setVintageFilter('');
  };
  const filteredData = PORTFOLIO_DATA.filter(item => {
    if (strategyFilter && item.strategy !== strategyFilter) return false;
    if (vintageFilter && item.vintage !== vintageFilter) return false;
    return true;
  }).sort((a, b) => {
    if (sortBy === 'name-asc') return a.partnership.localeCompare(b.partnership);
    if (sortBy === 'name-desc') return b.partnership.localeCompare(a.partnership);
    if (sortBy === 'commitment-desc') {
      const aVal = parseFloat(a.commitment.replace(/[^0-9.-]+/g, ''));
      const bVal = parseFloat(b.commitment.replace(/[^0-9.-]+/g, ''));
      return bVal - aVal;
    }
    if (sortBy === 'nav-desc') {
      const aVal = parseFloat(a.nav.replace(/[^0-9.-]+/g, ''));
      const bVal = parseFloat(b.nav.replace(/[^0-9.-]+/g, ''));
      return bVal - aVal;
    }
    if (sortBy === 'pct-desc') {
      const aVal = parseFloat(a.pctTotalNav.replace('%', ''));
      const bVal = parseFloat(b.pctTotalNav.replace('%', ''));
      return bVal - aVal;
    }
    return 0;
  });
  return <div className="animate-in fade-in duration-300" data-id="element-354">
      {/* Summary Stats Container */}
      <div className="bg-[#f4f5f5] rounded-xl p-6 mb-8" data-id="element-355">
        {/* Row 1 */}
        <div className="grid grid-cols-3 gap-5 mb-5" data-id="element-356">
          <div className="bg-white rounded-lg border border-gray-200 p-5" data-id="element-357">
            <p className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-358">
              # of funds
            </p>
            <p className="text-2xl font-bold text-[#458b85] mt-1.5" data-id="element-359">17</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-5" data-id="element-360">
            <div className="flex justify-between items-start" data-id="element-361">
              <p className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-362">
                Total Commitments
              </p>
              <div className="text-xs border border-gray-300 rounded px-2 py-0.5 text-gray-500 inline-flex items-center gap-1" data-id="element-363">
                USD <ChevronDown className="w-3 h-3" data-id="element-364" />
              </div>
            </div>
            <p className="text-2xl font-bold text-[#458b85] mt-1.5" data-id="element-365">
              $482,000,000.00
            </p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-5" data-id="element-366">
            <div className="flex justify-between items-start" data-id="element-367">
              <p className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-368">
                Total Unfunded
              </p>
              <div className="text-xs border border-gray-300 rounded px-2 py-0.5 text-gray-500 inline-flex items-center gap-1" data-id="element-369">
                USD <ChevronDown className="w-3 h-3" data-id="element-370" />
              </div>
            </div>
            <p className="text-2xl font-bold text-[#458b85] mt-1.5" data-id="element-371">
              $137,919,931.00
            </p>
          </div>
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-3 gap-5" data-id="element-372">
          <div className="bg-white rounded-lg border border-gray-200 p-5" data-id="element-373">
            <p className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-374">
              # of GPs
            </p>
            <p className="text-2xl font-bold text-[#458b85] mt-1.5" data-id="element-375">17</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-5" data-id="element-376">
            <p className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-377">
              Fund Vintages
            </p>
            <p className="text-2xl font-bold text-[#458b85] mt-1.5" data-id="element-378">
              2015-2021
            </p>
          </div>
          <div data-id="element-379"></div>
        </div>
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-3 gap-5 mb-8" data-id="element-380">
        {/* Strategies Chart */}
        <div className="bg-white rounded-lg border border-gray-200 p-5 h-[300px] flex flex-col" data-id="element-381">
          <h3 className="text-base font-bold text-gray-900 mb-4" data-id="element-382">Strategies</h3>
          <div className="flex-1 min-h-0" data-id="element-383">
            <ResponsiveContainer width="100%" height="100%" data-id="element-384">
              <PieChart data-id="element-385">
                <Pie data={STRATEGY_DATA} cx="50%" cy="50%" innerRadius={40} outerRadius={70} paddingAngle={2} dataKey="value" label={renderCustomizedLabel} labelLine={{
                stroke: '#cbd5e1',
                strokeWidth: 1
              }} data-id="element-386">
                  {STRATEGY_DATA.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-387" />)}
                </Pie>
                <Tooltip formatter={value => `${value}%`} data-id="element-388" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Geography Chart */}
        <div className="bg-white rounded-lg border border-gray-200 p-5 h-[300px] flex flex-col" data-id="element-389">
          <h3 className="text-base font-bold text-gray-900 mb-4" data-id="element-390">Geography</h3>
          <div className="flex-1 min-h-0" data-id="element-391">
            <ResponsiveContainer width="100%" height="100%" data-id="element-392">
              <PieChart data-id="element-393">
                <Pie data={GEOGRAPHY_DATA} cx="50%" cy="50%" innerRadius={40} outerRadius={70} paddingAngle={2} dataKey="value" label={renderCustomizedLabel} labelLine={{
                stroke: '#cbd5e1',
                strokeWidth: 1
              }} data-id="element-394">
                  {GEOGRAPHY_DATA.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-395" />)}
                </Pie>
                <Tooltip formatter={value => `${value}%`} data-id="element-396" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Vintage Distribution Chart */}
        <div className="bg-white rounded-lg border border-gray-200 p-5 h-[300px] flex flex-col" data-id="element-397">
          <h3 className="text-base font-bold text-gray-900 mb-4" data-id="element-398">
            Vintage Distribution
          </h3>
          <div className="flex-1 min-h-0" data-id="element-399">
            <ResponsiveContainer width="100%" height="100%" data-id="element-400">
              <BarChart data={VINTAGE_DATA} margin={{
              top: 20,
              right: 0,
              left: -20,
              bottom: 0
            }} data-id="element-401">
                <XAxis dataKey="year" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} data-id="element-402" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6b7280'
              }} label={{
                value: '$ (millions)',
                angle: -90,
                position: 'insideLeft',
                style: {
                  textAnchor: 'middle',
                  fontSize: 11,
                  fill: '#9ca3af'
                }
              }} data-id="element-403" />
                <Tooltip cursor={{
                fill: '#f3f4f6'
              }} data-id="element-404" />
                <Legend iconType="square" iconSize={10} wrapperStyle={{
                fontSize: 11,
                color: '#6b7280'
              }} data-id="element-405" />
                <Bar dataKey="NAV" stackId="a" fill="#458b85" radius={[0, 0, 4, 4]} data-id="element-406" />
                <Bar dataKey="Unfunded" stackId="a" fill="#e07a5f" radius={[4, 4, 0, 0]} data-id="element-407" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Filter Bar */}
      <FilterBar filters={filters} filterValues={filterValues} onFilterChange={handleFilterChange} onClearAll={handleClearAll} sortOptions={sortOptions} sortValue={sortBy} onSortChange={setSortBy} actions={<>
            <button className="flex items-center border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 rounded-md px-3.5 py-2 text-sm font-medium transition-colors" data-id="element-409">
              <ExternalLink className="w-4 h-4 mr-2" data-id="element-410" />
              Export
            </button>
            <button className="flex items-center border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 rounded-md px-3.5 py-2 text-sm font-medium transition-colors" data-id="element-411">
              <PlusCircle className="w-4 h-4 mr-2" data-id="element-412" />
              Add Interest
            </button>
          </>} data-id="element-408" />

      {/* Card-Table Hybrid Layout */}
      <div className="flex flex-col gap-3.5" data-id="element-413">
        {filteredData.map(row => {
        const commitmentNum = parseFloat(row.commitment.replace(/[^0-9.-]+/g, ''));
        const navNum = parseFloat(row.nav.replace(/[^0-9.-]+/g, ''));
        const ratio = commitmentNum > 0 ? navNum / commitmentNum * 100 : 0;
        const pctNum = parseFloat(row.pctTotalNav.replace('%', ''));
        const radius = 14;
        const circumference = 2 * Math.PI * radius;
        const strokeDashoffset = circumference - pctNum / 100 * circumference;
        const strategyColor = STRATEGY_DATA.find(s => s.name === row.strategy)?.color || '#9ca3af';
        return <div key={row.id} className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 flex items-center gap-7 hover:border-gray-300 transition-colors" data-id="element-414">
              {/* LEFT: Fund info */}
              <div className="flex-shrink-0 w-[240px]" data-id="element-415">
                <div className="mb-2" data-id="element-416">
                  <GpBadge name={row.fundManager} data-id="element-417" />
                </div>
                <div className="mb-1.5" data-id="element-418">
                  <span className="inline-flex items-center bg-gray-100 text-gray-600 text-sm font-medium px-2.5 py-0.5 rounded" data-id="element-419">
                    {row.partnership}
                  </span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-420">
                  <span className="w-2 h-2 rounded-full inline-block" style={{
                backgroundColor: strategyColor
              }} data-id="element-421" />
                  <span className="text-sm text-gray-500" data-id="element-422">{row.strategy}</span>
                </div>
              </div>

              {/* MIDDLE: Financials + ratio bar */}
              <div className="flex-1 max-w-md" data-id="element-423">
                <div className="flex justify-between text-sm text-gray-500 mb-2" data-id="element-424">
                  <span data-id="element-425">
                    Commitment:{' '}
                    <span className="font-medium text-gray-700" data-id="element-426">
                      {row.commitment}
                    </span>
                  </span>
                  <span data-id="element-427">
                    NAV:{' '}
                    <span className="font-medium text-gray-700" data-id="element-428">{row.nav}</span>
                  </span>
                </div>
                <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-429">
                  <div className="h-full rounded-full transition-all duration-500" style={{
                width: `${Math.min(ratio, 100)}%`,
                backgroundColor: strategyColor
              }} data-id="element-430" />
                </div>
              </div>

              {/* RIGHT: Donut + vintage pill */}
              <div className="flex items-center gap-7 flex-shrink-0 ml-auto" data-id="element-431">
                <div className="flex flex-col items-center gap-1.5" data-id="element-432">
                  <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-433">
                    Vintage
                  </span>
                  <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-600 text-sm font-medium" data-id="element-434">
                    {row.vintage}
                  </span>
                </div>

                <div className="flex flex-col items-center gap-1.5" data-id="element-435">
                  <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-436">
                    % Total NAV
                  </span>
                  <div className="relative w-9 h-9 flex items-center justify-center" data-id="element-437">
                    <svg className="w-9 h-9 transform -rotate-90" data-id="element-438">
                      <circle cx="18" cy="18" r={radius} stroke="currentColor" strokeWidth="3" fill="transparent" className="text-gray-100" data-id="element-439" />
                      <circle cx="18" cy="18" r={radius} stroke="currentColor" strokeWidth="3" fill="transparent" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} className="text-[#458b85] transition-all duration-500" data-id="element-440" />
                    </svg>
                    <span className="absolute text-[10px] font-bold text-gray-700" data-id="element-441">
                      {Math.round(pctNum)}%
                    </span>
                  </div>
                </div>
              </div>

              {/* FAR RIGHT: Actions */}
              <div className="flex items-center gap-2 bg-red-50/50 px-2.5 py-2 rounded-md flex-shrink-0 ml-2" data-id="element-442">
                <button className="p-1.5 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Edit" data-id="element-443">
                  <Pencil className="w-4 h-4" data-id="element-444" />
                </button>
                <button className="p-1.5 text-red-300 hover:text-red-500 transition-colors" aria-label="Delete" data-id="element-445">
                  <Trash2 className="w-4 h-4" data-id="element-446" />
                </button>
              </div>
            </div>;
      })}

        {filteredData.length === 0 && <div className="bg-white rounded-lg border border-gray-200 p-12 text-center text-base text-gray-500" data-id="element-447">
            No portfolio items match the selected filters.
          </div>}
      </div>
    </div>;
}